var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopNavDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 19,
    viewBox: "0 0 21 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9 2.825H14v-.707A2.112 2.112 0 0011.9 0H9.1C7.942 0 7 .95 7 2.118v.707H2.1c-1.158 0-2.1.95-2.1 2.118v1.412a2.12 2.12 0 001.4 1.997v17.776c0 1.168.942 2.118 2.1 2.118h14c1.158 0 2.1-.95 2.1-2.118V8.352A2.12 2.12 0 0021 6.355V4.943a2.112 2.112 0 00-2.1-2.118zM8.4 2.118c0-.389.314-.706.7-.706h2.8c.386 0 .7.317.7.706v.707H8.4v-.707zm9.1 24.716h-14a.704.704 0 01-.7-.706V8.474h15.4v17.654c0 .39-.314.706-.7.706zm2.1-20.479c0 .39-.314.707-.7.707H2.1a.704.704 0 01-.7-.707V4.943c0-.39.314-.706.7-.706h16.8c.386 0 .7.317.7.706v1.412z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 9.886c-.387 0-.7.316-.7.706v14.124c0 .39.313.706.7.706.387 0 .7-.316.7-.706V10.592a.703.703 0 00-.7-.706zm-4.2 0c-.387 0-.7.316-.7.706v14.124c0 .39.313.706.7.706.387 0 .7-.316.7-.706V10.592a.703.703 0 00-.7-.706zm-4.2 0c-.387 0-.7.316-.7.706v14.124c0 .39.313.706.7.706.387 0 .7-.316.7-.706V10.592a.703.703 0 00-.7-.706z"
  }))));
}

export default SvgTopNavDelete;